module.exports = __webpack_public_path__ + "static/media/parent.5686d6d7.png";